/* @flow */
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { fromJS, Map } from 'immutable';
import createDebugger from 'debug';
const debug = createDebugger('app:modules:insights:epics'); // eslint-disable-line no-unused-vars

import {
  INIT,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  FETCH_UPDATED_TIME_RANGE,
} from './action-types.js';

import { SELECT_ENCLAVE } from 'modules/insights/action-types.js';
import { enclaveSelection, savedRanges } from 'modules/insights/getters.js';

const defaultRange = 7;

const generateDefaultRange = () => {

  const fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - defaultRange);

  return {
    from: fromDate.getTime(),
    to: new Date().getTime(),
  };
};

/* Format the response from the server and calculate total values */
const fromJSON = (response: Object) => {
  return fromJS(response)
    .updateIn(['data', 'personal'], data => {
      return data.reduce((counts, metric) => {
        return counts
          .update('TOTAL', 0, t => t + metric.get('count'))
          .set(metric.get('source'), metric.get('count'));
      }, Map());
    })
    .updateIn(['data', 'other'], data => {
      return data.reduce((counts, metric) => {
        return counts
          .update('TOTAL', 0, t => t + metric.get('count'))
          .set(metric.get('source'), metric.get('count'));
      }, Map());
    });
};

const fetchResults = (ajax, url) => ajax.get(url)
  .mergeMap(({ response }) => {
    return Observable.of({
      type: FETCH_SUCCESS,
      payload: fromJSON(response)
    });
  }).catch(err => Observable.of({ type: FETCH_FAILURE }));

/* For now we match the date range to the selection for insights; there
 * is no independent date control for metrics */
const initializeEpic = (action$, store, { ajax }) =>
  action$.ofType(INIT)
    .mergeMap(() => {
      const savedDateRanges = savedRanges(store.getState());
      const insights = savedDateRanges.get('insights');
      const { from, to } = insights.toJS();
      const url = `/services/insights/report-submissions?from=${from}&to=${to}`;
      return fetchResults(ajax, url);
    });

const changeEnclaveEpic = (action$, store, { ajax }) =>
  action$.ofType(SELECT_ENCLAVE)
    .mergeMap(() => {
      const { from, to } = generateDefaultRange();
      const selectedEnclaveId = enclaveSelection(store.getState()).get('enclaveId');
      const url = `/services/insights/report-submissions?enclave=${selectedEnclaveId}&from=${from}&to=${to}`;
      return fetchResults(ajax, url);
    });

const fetchUpdatedDateRangeEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_UPDATED_TIME_RANGE)
    .mergeMap(({ payload: { from, to }}) => {
      const selectedEnclaveId = enclaveSelection(store.getState()).get('enclaveId');
      const url = `/services/insights/report-submissions?enclave=${selectedEnclaveId}&from=${from}&to=${to}`;
      return fetchResults(ajax, url);
    });

export default combineEpics(
  initializeEpic,
  changeEnclaveEpic,
  fetchUpdatedDateRangeEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/metrics/epics.js